import type { HTMLAttributes } from 'react'
import type { Demand } from 'types/buyer'
import type { Offer } from 'types/seller'
import type { MatchStatus } from 'types/match'
import type { OptionProps } from 'components/Multiselect'

import { useState } from 'react'
import { STATUS } from 'common'
import copy from 'copy.json'
import Multiselect, { getSelectedValues } from './Multiselect'
import Filter from './Filter'
import InputLabel from './InputLabel'

type Props = {
  statuses: Demand['status'][] | Offer['status'][] | MatchStatus[]
  onChosenStatus: (statuses: Demand['status'][] & Offer['status'][] & MatchStatus[]) => void
} & HTMLAttributes<HTMLDivElement>

const text_form = copy.common.form

export default function StatusesFilter({ statuses, onChosenStatus, children, ...props }: Props) {
  const [options, setOptions] = useState<OptionProps[]>(
    statuses.map(status => ({
      value: status,
      name: STATUS[status],
      isChecked: false
    }))
  )

  const handleStatusChange = (options: OptionProps[]) => {
    onChosenStatus(
      getSelectedValues(options) as Demand['status'][] & Offer['status'][] & MatchStatus[]
    )
    setOptions(options)
  }

  return (
    <Filter {...props}>
      <InputLabel>
        <span>{text_form.status}</span>
        <Multiselect options={options} onSelectionChange={handleStatusChange} />
      </InputLabel>

      {children}
    </Filter>
  )
}
